import { render } from "./MediaEditor.vue?vue&type=template&id=f32ccf7c&scoped=true"
import script from "./MediaEditor.vue?vue&type=script&lang=js"
export * from "./MediaEditor.vue?vue&type=script&lang=js"

import "./MediaEditor.vue?vue&type=style&index=0&id=f32ccf7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f32ccf7c"]])

export default __exports__